import { render, staticRenderFns } from "./KsatPaymentDetailsEdit.vue?vue&type=template&id=bc666f2c&"
import script from "./KsatPaymentDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./KsatPaymentDetailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports